import React from "react";

 import uflag from 'assets/image/uflag.jpg';
 import iranFlag from 'assets/image/iranFlag.png';

export const listFlagLang =[
    {img :iranFlag,dir:"rtl",lang:'fa' },
    {img :uflag,dir:"ltr", lang:'en' },
   /*  {img : ksaFlag,dir:"rtl",lang :'ar' }, */
]